import { render, staticRenderFns } from "./ChooseTeam.vue?vue&type=template&id=ece65a4a&scoped=true&"
import script from "./ChooseTeam.vue?vue&type=script&lang=js&"
export * from "./ChooseTeam.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTeam.vue?vue&type=style&index=0&id=ece65a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece65a4a",
  null
  
)

export default component.exports